const INTERVIEW_SCHEDULING_REQUEST_STATUS = {
  pending: "PENDING",
  ready: "READY",
  scheduled: "SCHEDULED",
  completed: "COMPLETED",
  canceled: "CANCELED",
  expired: "EXPIRED",
};

export { INTERVIEW_SCHEDULING_REQUEST_STATUS };
